<!--Grid row-->
<section class="team-section text-center my-5 ">

  <h2 class="h1-responsive color-primary my-5">Ihr Weg zu uns</h2>

  <p class="px-5 mb-5 pb-3 lead text-dark col-lg-8 mx-auto">
    Unsere Praxis befindet sich in der Stolberger Altstadt direkt unterhalb der Burg. Fußläufig erreichen Sie uns in wenigen Minuten von den Parkplätzen am Heinrich-Böll-Platz und Umgebung, von der Bushaltestelle „Altstadt“ (Linie 1, 8, 25, 40, 61 und 125), sowie der Regionalbahnhaltestelle „Stolberg-Altstadt“ (Linie RB20) der Euregiobahn.     </p>
        

  <div class="row">


    <!--Grid column-->
    <div class="col-lg-6 mx-auto no-margin ">

      <div class="row">
        
        <div class="col-lg-6 no-margin   view overlay  mx-auto " style="padding:0px" *ngFor='let img of ["tuer_640.jpg"]'>
          <img src="../../assets/img/gallery/{{img}}" class="img-fluid" style="height:480px;max-height: 480px;width:auto;margin-left:auto;margin-right:auto" height="480px">
          <!--
          <div class="mask flex-center waves-effect waves-light  rgba-stylish-strong" mdbWavesEffect>
            <p class="white-text">Hier kann eint text erscheinen</p>
          </div>
          -->
        </div>
        <div class="col-lg-6 mx-auto no-margin ">
          <div *ngIf="!showMap">
             <p>Google Maps Karte</p>
             <p>Diese Webseite verwendet Google Maps um Kartenmaterial von Google einzubinden. Bitte beachten Sie dass hierbei Ihre persönlichen Daten erfasst und gesammelt werden können. Um die Karte von Google Maps zu sehen, stimmen Sie bitte zu, dass diese vom Google-Server geladen wird</p>
            <button (click)="showMap=true" type="button" class="btn btn-secondary">Zustimmen & Google Karte Anzeigen</button>

          </div>
        <!--Google map-->
        <div *ngIf="showMap" id="map-container-google-8" class="map-container-5" style="height: 480px;max-width:640px;margin-left:auto;margin-right:auto">
          <iframe [src]="trustedUrl" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
      </div>
      </div>

    </div>
    <!--Grid column-->
  </div>
</section>
<!--Grid row-->